module.exports = __webpack_public_path__ + "images/8ea60ef5ed8fb2c5f0c79721625243e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-characters02.jpg
// module id = ./webpack/assets/img/diaryofanant-characters02.jpg
// module chunks = 0